export const ALERT_MESSAGES = {
  NETWORK_ISSUE_FILE_UPLOAD:
    'File is failing to upload. Please check your network.',
  FILE_UPLOAD_FAILING: 'File is failing to upload.',
  FILE_UPLOAD_SUCCESS: 'Files uploaded and saved successfuly.',
  NO_FILES: 'No files to upload.',
  GENERIC_ERROR: 'Something went wrong.',
  FILE_TYPE_VALIDATION: 'Please upload correct file type.',
  SUBMIT_SUCCESS: 'Data submitted successfuly.',
  FORM_SUBMIT_SUCCESS: 'Form submitted successfuly.',
  FILE_UPLOAD_INCORRECT_HEADER: 'The file you uploaded does not match with the template. Please download template and compare.',
  FILE_EMPTY: 'Uploaded file is empty.',
  FORM_NOT_FOUND: 'Form Not Found',
  NO_PERMISSION: 'You do not have access to this resource',
};
